import { v4 as uuid } from 'uuid';
import { types } from 'mobx-state-tree';


export default types.optional(types.identifier, () => uuid());
